import { formatSelectionsArray, truncateSelectedValues } from './utils'
import { fuelTypesData } from '@cinch-nx/data-search'

export const getFormattedFuelType = (fuelTypeSelections: string[] = []) =>
  truncateSelectedValues(
    formatSelectionsArray(fuelTypeSelections, fuelTypesData),
  )
